export const SET_CLIENTS = 'SET_CLIENTS';

export const setClients = (clients) => ({
  type: SET_CLIENTS,
  payload: clients,
});
